export default "__VITE_ASSET__BHnPW6IO__"